import { assembleBrandBoard } from './brandBoardPresentationV1.mjs';

export const brandStepUrl = (step, edit = false) => `/brand-studio/create${step ? `?step=${step}${edit ? '&intent=edit' : ''}` : ''}`;

export function myBrandLogoStatus(data) {
  const logo=data?.core?.selected_logo;
  if(!logo || logo.mode==='not_needed') return 'Пока без логотипа';
  const selection=data.typography?.selected_system;
  const current=!data.core.stale && logo.brand_name===data.profile?.brand_name
    && logo.palette_version===data.palette?.version_number && logo.palette_fingerprint===data.palette?.source_fingerprint
    && logo.typography_version===selection?.version_number && logo.typography_fingerprint===selection?.preferences_fingerprint;
  if(!current) return 'Логотип нужно перепроверить';
  return logo.status==='saved' ? 'Логотип сохранён · Не утверждён' : 'Пока без логотипа';
}

// A read-only view of existing decisions, never a new brand status or snapshot.
export function assembleMyBrand(data = {}) {
  const { profile, story, portrait, priorities, references, visualStyle, palette, typography } = data;
  const board = assembleBrandBoard(data);
  if (board.ready) return { state: 'ready', board };
  if (!profile && !story) return { state: 'empty', next: '/brand-studio/create?start=new' };
  const colors = palette?.status === 'approved' && palette.brand_profile_v2_id === profile?.id ? palette.colors : [];
  let next, message = '';
  const selected = typography?.selected_system;
  const paletteChanged = palette?.status === 'approved' && selected
    && (selected.palette_version !== palette.version_number || selected.palette_fingerprint !== palette.source_fingerprint);
  if (paletteChanged) {
    next = brandStepUrl('typography');
    message = 'Цвета изменились. Проверь сочетание шрифтов';
  } else if (palette?.status === 'approved' && palette.brand_profile_v2_id === profile?.id) {
    next = brandStepUrl('typography');
    message = selected?.status === 'approved' ? board.message : 'Выбери и утверди свои шрифты';
  } else if (palette && palette.brand_profile_v2_id === profile?.id) {
    next = brandStepUrl('visual-style');
  } else if (!story) {
    next = '/brand-studio/create?start=existing&context=story';
  } else if (!portrait || portrait.status !== 'confirmed' || portrait.source_story_id !== story.id || portrait.source_story_version !== story.source_version) {
    next = brandStepUrl('understanding');
  } else if (!profile?.brand_name?.trim()) {
    next = brandStepUrl('business-data');
  } else if (!priorities || (!priorities.needs?.length && !priorities.custom_text?.trim())) {
    next = brandStepUrl('needs');
  } else if (!references?.length || !visualStyle || visualStyle.status !== 'current') {
    next = brandStepUrl('references');
  } else {
    next = brandStepUrl('visual-style');
  }
  return { state: 'progress', brandName: profile?.brand_name || '', colors: colors || [], next, message };
}
